import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FlightSchoolFinderFilter } from '../models/flight-school-finder-filter.model';

/**
 * Shares the Flight School Finder filter state between the landing page, the results page, and the
 * filter-list component. Mirrors {@link FlyingClubFinderFiltersService} (a root-provided BehaviorSubject).
 */
@Injectable({
  providedIn: 'root'
})
export class FlightSchoolFinderFiltersService {

  private flightSchoolFinderFilterSubject$ = new BehaviorSubject<FlightSchoolFinderFilter>(new FlightSchoolFinderFilter());
  flightSchoolFinderFilter = this.flightSchoolFinderFilterSubject$.asObservable();

  constructor() { }

  updateFlightSchoolFinderFilters(flightSchoolFinderFilter: FlightSchoolFinderFilter) {
    this.flightSchoolFinderFilterSubject$.next(flightSchoolFinderFilter);
  }
}
